(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/common/pix-area.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/common/pix-area.js');

'use strict';

const {
  useDispatch
} = ReactRedux;
const Button = svs.ui.ReactButton;
const {
  getGameUrl,
  preventDoubleClick
} = svs.components.lbUtils;
const {
  TipsenModuleGameUrl,
  actions,
  PARAM_ACTION,
  PARAM_AMOUNT
} = svs.components.sport.tipsenShared;
const {
  showDialogAction
} = svs.components.marketplaceCompetition.services.actions.dialogActions;
const {
  Pix
} = svs.components.marketplaceShared.pix;
const logger = svs.core.log.getLogger('marketplace-competition:overview-hero');
const PixArea = _ref => {
  let {
    branding,
    competition,
    isMobile,
    isVisible
  } = _ref;
  const dispatch = useDispatch();
  const {
    currentDrawNumber,
    productId,
    systemNumber
  } = (competition === null || competition === void 0 ? void 0 : competition.details) || {};
  if (!isVisible) {
    return null;
  }
  const navigateToProductPage = _ref2 => {
    let {
      subPath,
      search
    } = _ref2;
    if (productId && currentDrawNumber) {
      const path = getGameUrl({
        productId,
        drawNumber: currentDrawNumber,
        options: {
          subPath,
          search
        }
      });
      if (path) {
        window.location.href = window.location.origin + path;
        return;
      }
    }
    logger.info("Could not create game url, competitionId: ".concat(competition === null || competition === void 0 ? void 0 : competition.id, " productId: ").concat(productId, " currentDrawNumber: ").concat(currentDrawNumber));
    dispatch(showDialogAction({
      title: 'Något gick fel',
      text: 'Vi kunde inte öppna sidan. Försök igen senare.',
      icon: 'exclamation-sign',
      type: 'error',
      buttons: [{
        text: 'Okej'
      }]
    }));
  };
  const handleSettleBetWithPix = () => navigateToProductPage({
    subPath: "/".concat(TipsenModuleGameUrl.PIX),
    search: "".concat(PARAM_ACTION, "=").concat(actions.OPEN_PIX, "&").concat(PARAM_AMOUNT, "=").concat(systemNumber)
  });
  return React.createElement(Pix, {
    branding: branding
  }, React.createElement("div", {
    className: "competition-center-to-screen"
  }, React.createElement(Button, {
    "aria-label": "K\xF6p en PIX",
    className: "buy-pix-button qa-competition-overview-hero-put-xpert-button",
    href: "".concat(getGameUrl({
      productId,
      drawNumber: currentDrawNumber,
      options: {
        subPath: "/".concat(TipsenModuleGameUrl.PIX),
        search: "".concat(PARAM_ACTION, "=").concat(actions.OPEN_PIX, "&").concat(PARAM_AMOUNT, "=").concat(systemNumber)
      }
    })),
    inverted: true,
    onClick: e => {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      preventDoubleClick(handleSettleBetWithPix);
    },
    size: isMobile ? 100 : 300,
    transparent: true
  }, "K\xF6p en PIX!")));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.common.PixArea', PixArea);

 })(window);